import { createContext } from "react";

export const AuthContext = createContext({ 
    isLoggedIn: false,
    userId: null,
    role: 'viewer',
    token: null,
     login: () => { }, 
     logout: () => { } 
    });